import { dramas } from '@/mocks/dramas';
import CategoryPage, { type CategoryConfig } from '@/pages/category/components/CategoryPage';

const latestList = dramas.filter((d) => d.year >= 2024);

const config: CategoryConfig = {
  slug: 'latest',
  title: '最新剧集',
  subtitle: 'New Release',
  intro:
    '最新剧集集中呈现近期上线或仍在更新的伦理题材作品。列表默认按上线时间排序，也可以切换为热度或评分，快速判断哪部更值得先看。',
  description:
    '新剧的价值往往在于它更贴近当下的生活经验：租房、通勤、两代人的育儿分歧、婚姻里的沉默成本。本页收录站内近期更新的伦理剧资料，包括更新状态与分集信息。点击任意卡片可进入详情页，查看完整剧情梗概、主创班底与相关推荐。所有数据均为站内演示内容。',
  base: latestList,
};

export default function LatestCategoryPage() {
  return <CategoryPage config={config} />;
}